import { render, staticRenderFns } from "./EstoqLine.vue?vue&type=template&id=60bb75bf&scoped=true"
import script from "./EstoqLine.vue?vue&type=script&lang=js"
export * from "./EstoqLine.vue?vue&type=script&lang=js"
import style0 from "./EstoqLine.vue?vue&type=style&index=0&id=60bb75bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb75bf",
  null
  
)

export default component.exports